module.exports = __webpack_public_path__ + "img/alert-icon-danger.08d47f47.svg";